import NavTabs from '../NavTabs';
import { SparklesIcon, ScissorsIcon, CubeIcon, ClockIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

const DataEditNav = () => {
  const { t } = useTranslation();

  const DATA_EDIT_TABS = [
    { label: t('nav.agroDataEdit'), to: 'agro', icon: SparklesIcon },
    { label: t('nav.pickingDataEdit'), to: 'picking', icon: ScissorsIcon },
    { label: t('nav.packingDataEdit'), to: 'packing', icon: CubeIcon },
    { label: t('nav.timingDataEdit'), to: 'timing', icon: ClockIcon }
  ];

  return <NavTabs tabs={DATA_EDIT_TABS} orientation="horizontal" />;
};

export default DataEditNav;
